import { render } from "./task-kal.vue?vue&type=template&id=a5454278&scoped=true"
import script from "./task-kal.vue?vue&type=script&lang=js"
export * from "./task-kal.vue?vue&type=script&lang=js"

import "./task-kal.vue?vue&type=style&index=0&id=a5454278&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5454278"]])

export default __exports__